module.exports = __webpack_public_path__ + "assets/img/effect_(1).37d7094e.gif";